import axios from "axios";

export default {
  user: {
    check: (data) =>
      axios
        .post("/api/authPractitioners/check", { data })
        .then((res) => res.data),
    login: (data) =>
      axios
        .post("/api/authPractitioners/login", { data })
        .then((res) => res.data),

    signup: (data) =>
      axios
        .post("/api/authPractitioners/signup", { data })
        .then((res) => res.data),
    validatePractitioner: (pract) =>
      axios
        .post("/api/authPractitioners/validate_practitioner", { pract })
        .then((res) => res.data),
    validateToken: (token) =>
      axios.post("/api/authPractitioners/validate_token", { token }),
    resetPasswordRequest: (username) =>
      axios.post("/api/authPractitioners/reset_password_request", { username }),
    resetPassword: (data) =>
      axios.post("/api/authPractitioners/reset_password", { data }),

    practitionerInfo: (data) => {
      axios.post("/api/practitioners/practitionerInfo", { data });
    },
    checkFullname: (id) =>
      axios
        .get(`/api/practitioners/checkFullname/${id}`)
        .then((res) => res.data),

    getPractitioners: (data) => {
      return axios.post("/api/practitioners/allPractitioners", { data });
    },
    updatePractitioner: (data) => {
      axios.post("/api/practitioners/updatePractitioner", { data });
    },
    approvePractitioner: (data) => {
      axios.post("/api/practitioners/approvePractitioner", { data });
    },
    delete: (id) =>
      axios.delete(`/api/practitioners/delete/${id}`).then((res) => res.data),
    getEntities: (data) => {
      // console.log(data);
      return axios.post("/api/entities/allEntities", { data });
    },

    fetchPractitionerAgreements: (id) => {
      axios.get(`/api/practitioners/agreements/${id}`);
    },
    updatePractitionerAgreements: ({
      agreement_id,
      accepted,
      agreement_name,
    }) =>
      axios
        .post("/api/practitioners/agreements", {
          agreement_id,
          accepted,
          agreement_name,
        })
        .then((res) => res.data),

    getAllPasswordConfigurations: () => axios.get(`/api/passwordConfigurations/getOne`),

    getTestOrderResult: (data) => axios.post(`/api/practitioners/testResults`)
    .then((res) => res.data),

  },
  entities: {
    delete: (id) =>
      axios.delete(`/api/entities/delete/${id}`).then((res) => res.data),
    approveEntity: (data) =>
      axios
        .post("/api/entities/approveEntity/", { data })
        .then((res) => res.data),
    entityResults: (institucion_id) => {
      return axios
        .get(`/api/entities/entityResults/${institucion_id}`)
        .then((res) => res.data);
    },
  },
  relations: {
    relationsByEntity: (entity) => {
      axios
        .get(`/api/relations/relationsByEntity/${entity}`)
        .then((res) => res.data);
    },
    relationsByEntityUser: async (entityUser) => {
      let resp = await axios.get(
        `/api/relations/relationsByEntityUser/${entityUser}`
      );

      if (resp) {
        // console.log(resp.data, "res api");
        return resp.data;
      }
    },
    relationsByUser: (username) =>
      axios
        .get(`/api/relations/relationsByUser/${username}`)
        .then((res) => res.data),
    addRelation: (data) =>
      axios
        .post("/api/relations/addRelation", { data })
        .then((res) => res.data),
    deleteRelation: (medico_id, institucion_id) =>
      axios
        .delete(`/api/relations/deleteRelation/${medico_id}/${institucion_id}`)
        .then((res) => res.data),
  },
  cities: {
    search: (input) => axios.get(`/api/cities/${input}`),
  },
  patients: {
    getPatients: () =>
      axios.get("/api/practitioners/getPatients").then((res) => res.data),
      // Motato Luis 13/06/22 se agrega llamado a nuevo servicio para el super usuario
    /*getPatientsSU: () =>
      axios.get("/api/practitioners/getPatientsSU").then((res) => res.data),*/
    lastTenResults: (id) =>
      axios
        .get(`/api/practitioners/lastTenResults/${id}`)
        .then((res) => res.data),
      // Motato Luis 13/06/22 se agrega llamado a nuevo servicio para el super usuario
    /*lastTenResultsSU: (id) =>
      api
        .get(`/api/practitioners/lastTenResultsSU/${id}`)
        .then((res) => res.data),*/
    entityResults: (institucion_id) =>
      axios
        .get(`/api/practitioners/entityResults/:${institucion_id}`)
        .then((res) => res.data),
    allPatientOrders: (data) =>
      axios
        .post("/api/practitioners/allPatientOrders", { data })
        .then((res) => res.data),
    patientOrderResults: (data) =>
      axios
        .post("/api/practitioners/patientOrderResults", { data })
        .then((res) => res.data),
    patientOrderResultsOne: (data) =>
      axios
        .post("/api/practitioners/patientOrderResultsOne", { data })
        .then((res) => res.data),
    patientHistoric: (data) =>
      axios
        .post("/api/practitioners/patientHistoric", { data })
        .then((res) => res.data),
  },
  agreements: {
    fetchAgreements: () => axios.get("/api/agreements").then((res) => res.data),
  },
};
